import { useLang } from "../../i18n/LangContext";
import { LegalPage, H2, P, UL, Placeholder } from "../../components/LegalPage";

export default function Privacy() {
  const { lang } = useLang();
  return (
    <LegalPage titlePl="Polityka prywatności" titleEn="Privacy policy" lang={lang} testId="privacy-page">
      {lang === "pl" ? (
        <>
          <P>Twoja prywatność jest dla nas priorytetowa. Ta polityka opisuje, jakie dane zbieramy, w jakim celu i jakie masz prawa zgodnie z RODO (Rozporządzenie 2016/679).</P>

          <H2>1. Administrator danych</H2>
          <P>Administratorem Twoich danych osobowych jest <Placeholder>Mateusz Zalewski</Placeholder>, <Placeholder>Wołomin ul. Szkolna 2 05-200 </Placeholder>,  Kontakt w sprawach RODO: <Placeholder>kontakt@mateuszzalewski.pl</Placeholder>.</P>

          <H2>2. Jakie dane zbieramy</H2>
          <UL>
            <li><b>Treści analiz:</b> rozmowy, opisy profili i obrazy, które dobrowolnie wprowadzasz do formularza analizy.</li>
            <li><b>Dane techniczne:</b> adres IP, typ przeglądarki, czas wizyty (logi serwera).</li>
            <li><b>Dane konta:</b> adres e-mail (oraz opcjonalnie imię i zdjęcie profilowe przy logowaniu Google). Rejestracja e-mail/hasło lub logowanie Google. Hasła przechowujemy wyłącznie w postaci zahaszowanej (bcrypt).</li>
            <li><b>Dane e-mail / newsletter:</b> adres e-mail zbierany podczas rejestracji, logowania oraz zapisu do kursu/newslettera jest wykorzystywany do wysyłki wiadomości z poradami i informacjami o usłudze. Zgoda marketingowa — art. 6 ust. 1 lit. a RODO. Możesz ją wycofać w każdej chwili (link „wypisz się" w każdym e-mailu).</li>
            <li><b>Dane płatności:</b> obsługiwane wyłącznie przez Stripe. My otrzymujemy jedynie id sesji, status płatności i kwotę. Numery kart NIE są przechowywane na naszych serwerach.</li>
          </UL>

          <H2>3. Cel i podstawa prawna przetwarzania</H2>
          <UL>
            <li>Wykonanie usługi analizy AI — art. 6 ust. 1 lit. b RODO (umowa).</li>
            <li>Obsługa płatności — art. 6 ust. 1 lit. b i c RODO (umowa, obowiązek prawny).</li>
            <li>Bezpieczeństwo i zapobieganie nadużyciom (logi) — art. 6 ust. 1 lit. f RODO (uzasadniony interes).</li>
          </UL>

          <H2>4. Odbiorcy danych</H2>
          <UL>
            <li><b>OpenRouter Inc.</b> (USA) — treści przesyłane do analizy AI (model deepseek/deepseek-chat-v3-0324 i openai/gpt-4o-mini).</li>
            <li><b>Stripe, Inc.</b> (USA) — przetwarzanie płatności.</li>
            <li><b>MongoDB Atlas</b> — przechowywanie raportów.</li>
          </UL>
          <P>Przekazania danych do USA odbywają się na podstawie standardowych klauzul umownych (SCC) Komisji Europejskiej.</P>

          <H2>5. Okres przechowywania</H2>
          <UL>
            <li>Raporty: przechowywane do momentu ich usunięcia przez Ciebie.</li>
            <li>Linki publiczne (share): wygasają automatycznie po 7 dniach.</li>
            <li>Logi serwera: do 90 dni.</li>
            <li>Dane transakcji płatniczych: 6 lat (obowiązek księgowy).</li>
          </UL>

          <H2>6. Twoje prawa (RODO)</H2>
          <UL>
            <li>Prawo dostępu do danych (art. 15).</li>
            <li>Prawo do sprostowania (art. 16).</li>
            <li>Prawo do usunięcia (&ldquo;prawo do bycia zapomnianym&rdquo;, art. 17) — możesz usunąć każdy raport przyciskiem w historii.</li>
            <li>Prawo do ograniczenia przetwarzania (art. 18).</li>
            <li>Prawo do przenoszenia danych (art. 20) — możesz pobrać raport jako PDF.</li>
            <li>Prawo do sprzeciwu (art. 21).</li>
            <li>Prawo do wniesienia skargi do Prezesa UODO.</li>
          </UL>

          <H2>7. Bezpieczeństwo</H2>
          <P>Stosujemy szyfrowanie TLS w transporcie, hasło JWT dla autoryzacji oraz ograniczamy dostęp do bazy danych. Klucze API są przechowywane wyłącznie po stronie serwera.</P>

          <H2>8. Zmiany polityki</H2>
          <P>Zastrzegamy prawo do aktualizacji niniejszej polityki. Data ostatniej aktualizacji widoczna na górze strony.</P>
        </>
      ) : (
        <>
          <P>Your privacy is a priority. This policy describes what data we collect, why, and the rights you have under GDPR (Regulation 2016/679).</P>

          <H2>1. Data controller</H2>
          <P>The data controller is <Placeholder>[YOUR COMPANY]</Placeholder>, <Placeholder>[ADDRESS]</Placeholder>, VAT-ID: <Placeholder>[VAT]</Placeholder>. GDPR contact: <Placeholder>[email@example.com]</Placeholder>.</P>

          <H2>2. What data we collect</H2>
          <UL>
            <li><b>Analysis content:</b> conversations, profile descriptions, and images you voluntarily provide.</li>
            <li><b>Technical data:</b> IP address, browser type, visit time (server logs).</li>
            <li><b>Account data:</b> email address (and optionally name and profile picture for Google sign-in). Email/password registration or Google sign-in. Passwords are stored hashed only (bcrypt).</li>
            <li><b>Email / newsletter data:</b> the email collected during registration, sign-in and newsletter/course signup is used to send tips and service information. Marketing consent — Art. 6(1)(a) GDPR. You can withdraw it anytime (unsubscribe link in every email).</li>
            <li><b>Payment data:</b> handled exclusively by Stripe. We only receive session id, payment status and amount. Card numbers are NEVER stored on our servers.</li>
          </UL>

          <H2>3. Purpose and legal basis</H2>
          <UL>
            <li>Performing the AI analysis service — Art. 6(1)(b) GDPR (contract).</li>
            <li>Payment processing — Art. 6(1)(b) and (c) GDPR.</li>
            <li>Security and abuse prevention (logs) — Art. 6(1)(f) (legitimate interest).</li>
          </UL>

          <H2>4. Recipients</H2>
          <UL>
            <li><b>OpenRouter Inc.</b> (USA) — content sent for AI analysis.</li>
            <li><b>Stripe, Inc.</b> (USA) — payment processing.</li>
            <li><b>MongoDB Atlas</b> — report storage (if cloud is used).</li>
          </UL>
          <P>Transfers to the USA occur under EU standard contractual clauses (SCC).</P>

          <H2>5. Retention</H2>
          <UL>
            <li>Reports: kept until you delete them.</li>
            <li>Public share links: expire after 7 days.</li>
            <li>Server logs: up to 90 days.</li>
            <li>Payment transactions: 6 years (accounting obligation).</li>
          </UL>

          <H2>6. Your GDPR rights</H2>
          <UL>
            <li>Right of access (Art. 15).</li>
            <li>Right to rectification (Art. 16).</li>
            <li>Right to erasure (Art. 17) — delete any report from your history.</li>
            <li>Right to restrict processing (Art. 18).</li>
            <li>Right to data portability (Art. 20) — download reports as PDF.</li>
            <li>Right to object (Art. 21).</li>
            <li>Right to lodge a complaint with the supervisory authority.</li>
          </UL>

          <H2>7. Security</H2>
          <P>We use TLS in transit, JWT authorization and restricted database access. API keys are kept server-side only.</P>

          <H2>8. Changes</H2>
          <P>We may update this policy. The &ldquo;last updated&rdquo; date is shown at the top.</P>
        </>
      )}
    </LegalPage>
  );
}
